import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { useHistory } from "react-router";
import { Image, Input } from "antd";
import { hideScrollbar, inputStyle } from "../../lib/styles/styleLibrary";
import { isEmpty, onlyNumberInput, Toast } from "../../lib/helpers/helpers";
import { EyeTwoTone } from "@ant-design/icons";
import Auth from "../../lib/middleware/auth";
import lock from "../../assets/svg/lock.svg";
import pwd_hidden from "../../assets/svg/pwd_hidden_eye.svg";
import {
	changePassword,
	changePin,
	forgotPin,
	setPin,
	viewUserProfile,
} from "../../redux/actions/authentication";
import errorHandler from "../../redux/actions/errorHandler";
import { useMutation } from "react-query";
import { PageLoading } from "..";
import { ROUTES } from "../../settings/routes";
import mail from "../../assets/svg/message.svg";

const Wrapper = styled.div`
	${tw`w-full md:w-9/12 overflow-y-scroll mt-8`}
	height: calc(100vh - 15rem);

	@media (max-width: 1023px) {
		width: 100% !important;
		height: calc(100vh - 12rem);
	}
	.label {
		${tw`text-appTextDark opacity-50 font-semibold text-sm md:text-base`}
	}

	.form-control {
		${tw`pt-3 flex flex-row flex-nowrap items-center justify-between gap-1 md:gap-4`}
	}

	.ant-input {
		font-size: 0.75rem;
	}
	.ant-select-selection-search-input {
		padding-top: 15px !important;
	}
	.ant-select-selection-item,
	.ant-select-selection-placeholder {
		padding-top: 10px !important;
		/* color: #dedef0 !important; */
	}
	.ant-select-selection-placeholder {
		color: #db0a0a !important;
	}
	.ant-select-selector {
		${tw`shadow-sm`}
		border-radius: 12px !important;
		height: 50px !important;
		min-width: 15rem !important;
		border: 1px solid #dedef0 !important;
	}
	.ant-picker-input > input {
		padding-left: 30px;
	}
	.ant-radio {
		top: 0;
	}
	.ant-radio-wrapper {
		${tw`inline-flex items-center`}
		font-size: 12px;
		line-height: 21px;
		color: #323232;
		opacity: 0.7;

		.ant-radio-inner {
			${tw`h-6 w-6`}
			background: rgba(20, 20, 20, 0.06);
			border: 1px solid #ff5a62;
			&::after {
				content: "";
				background: #fff;
				border: 1px solid #ddd;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 16px;
				height: 16px;
				padding: 2px;
			}
		}
		.ant-radio-checked {
			background: #ff5a62 !important;
			border: 1px solid #ff5a62 !important;
			border-radius: 50%;
		}
	}
`;

const  AccountSettings = (props) => {
	const history = useHistory();
	const user = Auth.getUser();

	useEffect(() => {
		viewUserProfile();
	}, []);

	const [walletPin, setWalletPin] = useState({
		email: user?.email,
		old_pin: "",
		new_pin: "",  
		pin: "",
		confirm_new_pin: "",
	});

	const [pass, setPass] = useState({
		email: user?.email,
		old_password: "",
		new_password: "",
		confirm_password: "",
	});

	const { mutateAsync: handleChangePassword, isLoading: pwdLoading } =
		useMutation(changePassword);

	const handlePassword = async () => {
		if (isEmpty(pass.email)) {
			return;
		}
		if (isEmpty(pass.new_password) || isEmpty(pass.confirm_password)) {
			Toast.fire({
				icon: "error",
				title: `Password cannot be empty`,
			});
			return;
		}

		if (pass.new_password !== pass.confirm_password) {
			Toast.fire({
				icon: "error",
				title: `Passwords do not match`,
			});
			return;
		}
		try {
			const res = await handleChangePassword(pass);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
			history.push(ROUTES.LOGIN);
			setTimeout(() => {
				Auth.destroyToken();
			}, 500);
		} catch (err) {
			console.log("the change password error", err);
		}
	};

	const { mutateAsync: handleChangePin, isLoading: pinLoading } =
		useMutation(changePin);

	const handlePin = async () => {
		if (isEmpty(walletPin.email)) {
			return;
		}
		if (isEmpty(walletPin.old_pin) || isEmpty(walletPin.new_pin)) {
			Toast.fire({
				icon: "error",
				title: `Pin cannot be empty`,
			});
			return;
		}
		if (walletPin.confirm_new_pin !== walletPin.new_pin) {
			Toast.fire({
				icon: "error",
				title: `Pins do match`,
			});
			return;
		}

		try {
			const res = await handleChangePin(walletPin);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
			setWalletPin({
				email: user?.email,
				old_pin: "",
				new_pin: "",
				pin: "",
			});
		} catch (err) {
			console.log("the change password error", err);
		}
	};

	const { mutateAsync: handleSetPin, isLoading: setPinLoading } =
		useMutation(setPin);

	const handleWalletPin = async () => {
		if (isEmpty(walletPin.old_pin)) {
			Toast.fire({
				icon: "error",
				title: `Pin cannot be empty`,
			});
			return;
		}

		const data = {
			pin: walletPin.old_pin,
		};

		try {
			const res = await handleSetPin(data);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
			viewUserProfile();
		} catch (err) {
			console.log("the change password error", err);
		}
	};

	const { mutateAsync: handleForgotPin, isLoading: forgotLoading } =
		useMutation(forgotPin);

	const handleForgot = async () => {
		if (isEmpty(walletPin.email)) {
			Toast.fire({
				icon: "error",
				title: `Pin cannot be empty`,
			});
			return;
		}

		const data = {
			email: walletPin.email,
		};

		try {
			const res = await handleForgotPin(data);
			console.log("reset pin res ", res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
		} catch (err) {
			console.log("the reset pin error", err);
		}
	};

	return (
		<Wrapper css={hideScrollbar}>
			<div tw="flex justify-end items-center w-full">
				<button
					onClick={handlePassword}
					tw="bg-appLightPink text-appPink rounded-2xl font-semibold px-3 py-1 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)">
					Save new password
				</button>
			</div>
			<div tw="mt-2">
				<label htmlFor="name" className="label">
					Change Password
				</label>
				<div tw="mt-4">
					<Input.Password
						placeholder="Current password"
						type="password"
						autoFocus
						css={inputStyle}
						value={pass.old_password}
						onChange={(e) => {
							setPass({
								...pass,
								old_password: e.target.value.trim(),
							});
						}}
						prefix={<img src={lock} alt="" tw="pr-2" />}
						iconRender={(visible) =>
							visible ? (
								<EyeTwoTone twoToneColor="#9797BD" />
							) : (
								<Image
									preview={false}
									src={pwd_hidden}
									alt=""
									width={20}
									height={20}
								/>
							)
						}
					/>
				</div>
				<div>
					<Input.Password
						placeholder="New password"
						type="password"
						css={inputStyle}
						value={pass.new_password}
						onChange={(e) => {
							setPass({
								...pass,
								new_password: e.target.value.trim(),
							});
						}}
						prefix={<img src={lock} alt="" tw="pr-2" />}
						iconRender={(visible) =>
							visible ? (
								<EyeTwoTone twoToneColor="#9797BD" />
							) : (
								<Image
									preview={false}
									src={pwd_hidden}
									alt=""
									width={20}
									height={20}
								/>
							)
						}
					/>
				</div>
				<div>
					<Input.Password
						placeholder="Confirm new password"
						type="password"
						css={inputStyle}
						value={pass.confirm_password}
						onChange={(e) => {
							setPass({
								...pass,
								confirm_password: e.target.value.trim(),
							});
						}}
						prefix={<img src={lock} alt="" tw="pr-2" />}
						iconRender={(visible) =>
							visible ? (
								<EyeTwoTone twoToneColor="#9797BD" />
							) : (
								<Image
									preview={false}
									src={pwd_hidden}
									alt=""
									width={20}
									height={20}
								/>
							)
						}
					/>
				</div>
			</div>

			{user?.is_wallet_blocked ? (
				<div tw="mt-12 mb-12">
					<div tw="flex justify-end items-center w-full">
						<button
							onClick={handleForgot}
							tw="bg-appLightPink text-appPink rounded-2xl font-semibold px-3 py-1 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)">
							Reset
						</button>
					</div>
					<label htmlFor="name" className="label">
						Reset Wallet PIN
					</label>
					<div tw="mt-4">
						<Input
							placeholder="Set wallet PIN"
							type="email"
							disabled
							css={inputStyle}
							value={walletPin.email}
							prefix={
								<img src={mail} alt="" tw="opacity-50 pr-2" />
							}
						/>
					</div>
				</div>
			) : user?.is_wallet_set ? (
				<div tw="mt-12 mb-12">
					<div tw="flex justify-end items-center w-full">
						<button
							onClick={handlePin}
							tw="bg-appLightPink text-appPink rounded-2xl font-semibold px-3 py-1 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)">
							Change wallet pin
						</button>
					</div>
					<label htmlFor="name" className="label">
						Wallet PIN
					</label>
					<div tw="mt-4">
						<Input.Password
							placeholder="Enter wallet PIN"
							type="password"
							css={inputStyle}
							onkeypress={(event) => onlyNumberInput(event)}
							value={walletPin.old_pin}
							onChange={(e) => {
								setWalletPin({
									...walletPin,
									old_pin: e.target.value.trim(),
								});
							}}
							prefix={<img src={lock} alt="" tw="pr-2" />}
							iconRender={(visible) =>
								visible ? (
									<EyeTwoTone twoToneColor="#9797BD" />
								) : (
									<Image
										preview={false}
										src={pwd_hidden}
										alt=""
										width={20}
										height={20}
									/>
								)
							}
						/>
					</div>
					<div>
						<Input.Password
							placeholder="New wallet PIN"
							type="password"
							css={inputStyle}
							value={walletPin.new_pin}
							onChange={(e) => {
								setWalletPin({
									...walletPin,
									new_pin: e.target.value.trim(),
								});
							}}
							prefix={<img src={lock} alt="" tw="pr-2" />}
							iconRender={(visible) =>
								visible ? (
									<EyeTwoTone twoToneColor="#ddd" />
								) : (
									<Image
										preview={false}
										src={pwd_hidden}
										alt=""
										width={20}
										height={20}
									/>
								)
							}
						/>
					</div>
					<div>
						<Input.Password
							placeholder="Confirm New PIN"
							type="password"
							css={inputStyle}
							value={walletPin.confirm_new_pin}
							onChange={(e) => {
								setWalletPin({
									...walletPin,
									confirm_new_pin: e.target.value.trim(),
								});
							}}
							prefix={<img src={lock} alt="" tw="pr-2" />}
							iconRender={(visible) =>
								visible ? (
									<EyeTwoTone twoToneColor="#ddd" />
								) : (
									<Image
										preview={false}
										src={pwd_hidden}
										alt=""
										width={20}
										height={20}
									/>
								)
							}
						/>
					</div>
				</div>
			) : (
				<div tw="mt-12 mb-12!">
					<div tw="flex justify-end items-center w-full">
						<button
							onClick={handleWalletPin}
							tw="bg-appLightPink text-appPink rounded-2xl font-semibold px-3 py-1 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)">
							Set wallet pin
						</button>
					</div>
					<label htmlFor="name" className="label">
						Wallet PIN
					</label>
					<div tw="mt-4">
						<Input.Password
							placeholder="Set wallet PIN"
							type="password"
							css={inputStyle}
							maxLength={4}
							value={walletPin.old_pin}
							onChange={(e) => {
								setWalletPin({
									...walletPin,
									old_pin: e.target.value.trim(),
								});
							}}
							prefix={<img src={lock} alt="" tw="pr-2" />}
							iconRender={(visible) =>
								visible ? (
									<EyeTwoTone twoToneColor="#9797BD" />
								) : (
									<Image
										preview={false}
										src={pwd_hidden}
										alt=""
										width={20}
										height={20}
									/>
								)
							}
						/>
					</div>
				</div>
			)}

			{(pwdLoading || setPinLoading || pinLoading || forgotLoading) && (
				<PageLoading />
			)}
		</Wrapper>
	);
};

export default AccountSettings;
